import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontSourceSerif4, theme } from "shared/lib/styles";

import { ContentItemHomeThingsToDoV2 } from "scmp-app/components/content/content-item-render/variants/home-things-to-do-v2";

export const SectionTitle = styled.div`
  padding-block-end: 10px;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 90%;
  letter-spacing: -1.4px;
`;

export const SectionTitleLink = styled(BaseLink)`
  padding-block-end: 10px;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 90%;
  letter-spacing: -1.4px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;
  border-block-start: 1px #000000 solid;

  padding-block-start: 12px;
`;

export const ItemsContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 16px;
  justify-content: flex-start;

  ${theme.breakpoints.only("tablet")} {
    flex-flow: row nowrap;
    gap: 20px;
  }
`;

export const Item = styled(ContentItemHomeThingsToDoV2)`
  :not(:first-of-type) {
    border-block-start: 1px #dfdfdf solid;

    padding-block-start: 16px;

    ${theme.breakpoints.only("tablet")} {
      padding-block-start: 0;
      border-block-start: none;

      padding-inline-start: 20px;
      border-inline-start: 1px #dfdfdf solid;
    }
  }
`;
